import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	putContractsId,
	type UpdateContractRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export type ExtendedUpdateContractRequest = UpdateContractRequest & {
	contractId: string;
};

export const useUpdateContractMutation = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: processResponse((contract: ExtendedUpdateContractRequest) =>
			putContractsId(contract, contract.contractId),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["contracts"], exact: false });
		},
	});
};
